import './module/common';
//import './module/slick';
import './module/menu';
//import './module/parallax';
import './module/inview';
import './module/script';
//import './module/shuffle';
import './module/accordion';
//import './module/lower';
//import './module/modal';
//import './module/toc';
//import './module/holdnav';
import './module/floating';
import './module/formselect';

